import Flex from '@/component/atom/Flex';
import { $k18n } from '@/page/orderDetail/view/utils/tools';
import { Popup } from '@kibt/meta-ui-krn';
import IconClose from '@/assets/icon/icon_close.png';
import React, { useState } from 'react';
import { Text, StyleSheet, TouchableOpacity, View } from 'react-native';
import Image from '@kds/image';
import { styleGlobal, styles, vh } from '@/common/style';
import IconArrowRight from '@/assets/icon/arrow_right_grey.png';
import type { ShopCartItem } from '../index';
import { vIf } from '@/common/utils/vIf';
const pureStyle = {
    content: {
        backgroundColor: '#fff',
        height: vh(60),
        borderTopLeftRadius: 16,
        borderTopRightRadius: 16,
    },
};
const style = StyleSheet.create({
    title: {
        fontWeight: 'bold',
        fontSize: 18,
        flex: 1,
        textAlign: 'center',
    },
    closeIcon: {
        width: 24,
        height: 24,
    },
    discountText: {
        marginRight: 5,
    },
});
export function useCheckoutDetailPopup({ shopCartItem }: { shopCartItem: ShopCartItem }) {
    const [visible, setVisible] = useState(false);
    const [showDiscountDetail, setShowDiscountDetail] = useState(false);
    const shopDiscount = shopCartItem?.shopEvaluate?.shopDiscount;
    const popupNode = (bottom, height) => (
        <View style={{ zIndex: 1 }}>
            <Popup
                visible={visible}
                maskZindex={101}
                onClose={() => {
                    setVisible(false);
                }}
                position="bottom"
                boxStyle={{ bottom }}
            >
                <Flex style={{ ...pureStyle.content, height }} flex={'flexCol'}>
                    <Flex style={{ alignItems: 'center', paddingHorizontal: 19, paddingVertical: 16 }} flex={'flexBtw'}>
                        <Text style={style.title}>{$k18n('优惠明细')}</Text>
                        <TouchableOpacity activeOpacity={0.6} onPress={() => setVisible(false)}>
                            <Image resizeMode="contain" style={style.closeIcon} source={IconClose} />
                        </TouchableOpacity>
                    </Flex>
                    <Flex flex={'flexCol'} style={{ padding: 19 }}>
                        <Flex flex={'flexBtw'}>
                            <Text style={styles({ color: '#000' })}>{$k18n('商品总价')}</Text>
                            <Text style={styles({ color: '#000' })}>{shopDiscount?.itemMarketDiscount?.origin?.displayAmount}</Text>
                        </Flex>
                        <Flex flex={'flexBtw'} style={{ marginVertical: 17 }}>
                            <Text style={styles({ color: '#000' })}>{$k18n('总折扣')}</Text>
                            <TouchableOpacity activeOpacity={0.6} onPress={() => setShowDiscountDetail(!showDiscountDetail)}>
                                <Flex flex={'flexRowCenter'}>
                                    <Text style={[style.discountText, styleGlobal.primaryColor]}>
                                        -{shopDiscount?.itemTotalDiscount?.displayAmount}
                                    </Text>
                                    <Image
                                        style={styles({
                                            width: 16,
                                            height: 16,
                                            transform: [{ rotate: showDiscountDetail ? '-90deg' : '90deg' }],
                                        })}
                                        source={IconArrowRight}
                                    />
                                    {/* <Arrow direction={showDiscountDetail ? 'up' : 'down'} /> */}
                                </Flex>
                            </TouchableOpacity>
                        </Flex>
                        {showDiscountDetail ? (
                            <>
                                {vIf(
                                    [!!shopDiscount?.itemMarketDiscount?.deduct?.amount],
                                    <Flex flex={'flexBtw'} style={{ marginBottom: 17 }}>
                                        <Text style={styles({ color: '#000' })}>{$k18n('商品折扣')}</Text>
                                        <Text style={styleGlobal.primaryColor}>-{shopDiscount?.itemMarketDiscount?.deduct?.displayAmount}</Text>
                                    </Flex>,
                                )}
                                {vIf(
                                    [!!shopDiscount?.itemCouponDiscount?.deduct?.amount],
                                    <Flex flex={'flexBtw'} style={{ marginBottom: 17 }}>
                                        <Text style={styles({ color: '#000' })}>{$k18n({ text: '优惠券', desc: 'C补-运费券' })}</Text>
                                        <Text style={styleGlobal.primaryColor}>-{shopDiscount?.itemCouponDiscount?.deduct?.displayAmount}</Text>
                                    </Flex>,
                                )}
                            </>
                        ) : null}
                        <Flex flex={'flexBtw'}>
                            <Text style={styles({ color: '#000' })}>{$k18n('合计金额')}</Text>
                            <Text>{shopDiscount?.itemCouponDiscount?.now?.displayAmount}</Text>
                        </Flex>
                    </Flex>
                </Flex>
            </Popup>
        </View>
    );
    return {
        visible,
        setVisible,
        popupNode,
    };
}
